import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueNotify from 'vue-notifyjs';
import router from '../main.js';
import moment from 'moment';

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(VueNotify, { type: 'danger', timeout: 5000, horizontalAlign: 'center', verticalAlign: 'top', });

import {
    Loading,
    MessageBox,
    Message,
    Notification
} from 'element-ui';


Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;



let notifier = new Vue();

const store = new Vuex.Store({
    state: {
        modal_help: false,
        modal_login: false,
        modal_reg: false,
        modal_password_new: false,
        modal_password_change: false,
        modal_password_forgot: false,
        modal_info: false,
        modal_info_text: "",

        modal_user: false,
        modal_user_ro: false,
        modal_patient: false,
        modal_patient_ro: false,
        modal_checkup: false,
        modal_checkup_ro: false,
        modal_examination: false,
        modal_examination_ro: false,
        modal_operation: false,
        modal_operation_ro: false,
        modal_medication: false,
        modal_medication_ro: false,
        modal_dashboard: false,

        id_user: localStorage.getItem('current_user'),
        loginuser: {},

        token: localStorage.getItem('token'),

        roles: [],

        my_role: 0,

        current_url: "",

        application: "NEON",

        l_countries: [
            { value: "CZE", label: "Česká republika" },
            { value: "AFG", label: "Afghánistán" },
            { value: "ALA", label: "Alandys" },
            { value: "ALB", label: "Albánie" },
            { value: "DZA", label: "Alžírsko" },
            { value: "ASM", label: "Americká Samoa" },
            { value: "VIR", label: "Americké Panenské ostrovy" },
            { value: "AND", label: "Andorra" },
            { value: "AGO", label: "Angola" },
            { value: "AIA", label: "Anguilla" },
            { value: "ATA", label: "Antarktida" },
            { value: "ATG", label: "Antigua a Barbuda" },
            { value: "ARG", label: "Argentina" },
            { value: "ARM", label: "Arménie" },
            { value: "ABW", label: "Aruba" },
            { value: "AUS", label: "Austrálie" },
            { value: "AZE", label: "Ázerbájdžán" },
            { value: "BHS", label: "Bahamy" },
            { value: "BHR", label: "Bahrajn" },
            { value: "BGD", label: "Bangladéš" },
            { value: "BRB", label: "Barbados" },
            { value: "BEL", label: "Belgie" },
            { value: "BLZ", label: "Belize" },
            { value: "BLR", label: "Bělorusko" },
            { value: "BEN", label: "Benin" },
            { value: "BMU", label: "Bermudy" },
            { value: "BTN", label: "Bhútán" },
            { value: "BOL", label: "Bolívie" },
            { value: "BES", label: "Bonaire, Svatý Eustach a Saba" },
            { value: "BIH", label: "Bosna a Hercegovina" },
            { value: "BWA", label: "Botswana" },
            { value: "BVT", label: "Bouvetův ostrov" },
            { value: "BRA", label: "Brazílie" },
            { value: "IOT", label: "Britské indickooceánské území" },
            { value: "VGB", label: "Britské Panenské ostrovy" },
            { value: "BRN", label: "Brunej" },
            { value: "BGR", label: "Bulharsko" },
            { value: "BFA", label: "Burkina Faso" },
            { value: "BDI", label: "Burundi" },
            { value: "COK", label: "Cookovy ostrovy" },
            { value: "CUW", label: "Curaçao" },
            { value: "TCD", label: "Čad" },
            { value: "MNE", label: "Černá Hora" },
            { value: "CHN", label: "Čína" },
            { value: "DNK", label: "Dánsko" },
            { value: "COD", label: "Konžská demokratická republika" },
            { value: "DMA", label: "Dominika" },
            { value: "DOM", label: "Dominikánská republika" },
            { value: "DJI", label: "Džibutsko" },
            { value: "EGY", label: "Egypt" },
            { value: "ECU", label: "Ekvádor" },
            { value: "ERI", label: "Eritrea" },
            { value: "EST", label: "Estonsko" },
            { value: "ETH", label: "Etiopie" },
            { value: "FRO", label: "Faerské ostrovy" },
            { value: "FLK", label: "Falklandy (Malvíny)" },
            { value: "FJI", label: "Fidži" },
            { value: "PHL", label: "Filipíny" },
            { value: "FIN", label: "Finsko" },
            { value: "FRA", label: "Francie" },
            { value: "GUF", label: "Francouzská Guyana" },
            { value: "ATF", label: "Francouzská jižní a antarktická území" },
            { value: "PYF", label: "Francouzská Polynésie" },
            { value: "GAB", label: "Gabon" },
            { value: "GMB", label: "Gambie" },
            { value: "GHA", label: "Ghana" },
            { value: "GIB", label: "Gibraltar" },
            { value: "GRD", label: "Grenada" },
            { value: "GRL", label: "Grónsko" },
            { value: "GEO", label: "Gruzie" },
            { value: "GLP", label: "Guadeloupe" },
            { value: "GUM", label: "Guam" },
            { value: "GTM", label: "Guatemala" },
            { value: "GGY", label: "Guernsey" },
            { value: "GIN", label: "Guinea" },
            { value: "GNB", label: "Guinea-Bissau" },
            { value: "GUY", label: "Guyana" },
            { value: "HTI", label: "Haiti" },
            { value: "HMD", label: "Heardův ostrov a MacDonaldovy ostrovy" },
            { value: "HND", label: "Honduras" },
            { value: "HKG", label: "Hongkong" },
            { value: "CHL", label: "Chile" },
            { value: "HRV", label: "Chorvatsko" },
            { value: "IND", label: "Indie" },
            { value: "IDN", label: "Indonésie" },
            { value: "IRQ", label: "Irák" },
            { value: "IRN", label: "Írán" },
            { value: "IRL", label: "Irsko" },
            { value: "ISL", label: "Island" },
            { value: "ITA", label: "Itálie" },
            { value: "ISR", label: "Izrael" },
            { value: "JAM", label: "Jamajka" },
            { value: "JPN", label: "Japonsko" },
            { value: "YEM", label: "Jemen" },
            { value: "JEY", label: "Jersey" },
            { value: "ZAF", label: "Jižní" },
            { value: "SGS", label: "Jižní Georgie a Jižní Sandwichovy ostrovy" },
            { value: "SSD", label: "Jižní Súdán" },
            { value: "JOR", label: "Jordánsko" },
            { value: "CYM", label: "Kajmanské ostrovy" },
            { value: "KHM", label: "Kambodža" },
            { value: "CMR", label: "Kamerun" },
            { value: "CAN", label: "Kanada" },
            { value: "CPV", label: "Kapverdy" },
            { value: "QAT", label: "Katar" },
            { value: "KAZ", label: "Kazachstán" },
            { value: "KEN", label: "Keňa" },
            { value: "KIR", label: "Kiribati" },
            { value: "CCK", label: "Kokosové (Keelingovy) ostrovy" },
            { value: "COL", label: "Kolumbie" },
            { value: "COM", label: "Komory" },
            { value: "COG", label: "Konžská republika" },
            { value: "PRK", label: "Korejská lidově demokratická republika" },
            { value: "KOR", label: "Korejská republika" },
            { value: "XXK", label: "Kosovo " },
            { value: "CRI", label: "Kostarika" },
            { value: "CUB", label: "Kuba" },
            { value: "KWT", label: "Kuvajt" },
            { value: "CYP", label: "Kypr" },
            { value: "KGZ", label: "Kyrgyzstán" },
            { value: "LAO", label: "Laos" },
            { value: "LSO", label: "Lesotho" },
            { value: "LBN", label: "Libanon" },
            { value: "LBR", label: "Libérie" },
            { value: "LBY", label: "Libye" },
            { value: "LIE", label: "Lichtenštejnsko" },
            { value: "LTU", label: "Litva" },
            { value: "LVA", label: "Lotyšsko" },
            { value: "LUX", label: "Lucembursko" },
            { value: "MAC", label: "Macao" },
            { value: "MDG", label: "Madagaskar" },
            { value: "HUN", label: "Maďarsko" },
            { value: "MKD", label: "Severní Makedonie" },
            { value: "MYS", label: "Malajsie" },
            { value: "MWI", label: "Malawi" },
            { value: "MDV", label: "Maledivy" },
            { value: "MLI", label: "Mali" },
            { value: "MLT", label: "Malta" },
            { value: "IMN", label: "Man" },
            { value: "MAR", label: "Maroko" },
            { value: "MHL", label: "Marshallovy ostrovy" },
            { value: "MTQ", label: "Martinik" },
            { value: "MUS", label: "Mauricius" },
            { value: "MRT", label: "Mauritánie" },
            { value: "MYT", label: "Mayotte" },
            { value: "UMI", label: "Menší odlehlé ostrovy USA" },
            { value: "MEX", label: "Mexiko" },
            { value: "FSM", label: "Mikronésie" },
            { value: "MDA", label: "Moldavsko" },
            { value: "MCO", label: "Monako" },
            { value: "MNG", label: "Mongolsko" },
            { value: "MSR", label: "Montserrat" },
            { value: "MOZ", label: "Mosambik" },
            { value: "MMR", label: "Myanmar" },
            { value: "NAM", label: "Namibie" },
            { value: "NRU", label: "Nauru" },
            { value: "DEU", label: "Německo" },
            { value: "NPL", label: "Nepál" },
            { value: "NER", label: "Niger" },
            { value: "NGA", label: "Nigérie" },
            { value: "NIC", label: "Nikaragua" },
            { value: "NIU", label: "Niue" },
            { value: "NLD", label: "Nizozemsko" },
            { value: "NFK", label: "Norfolk" },
            { value: "NOR", label: "Norsko" },
            { value: "NCL", label: "Nová Kaledonie" },
            { value: "NZL", label: "Nový Zéland" },
            { value: "OMN", label: "Omán" },
            { value: "PAK", label: "Pákistán" },
            { value: "PLW", label: "Palau" },
            { value: "PSE", label: "Palestina" },
            { value: "PAN", label: "Panama" },
            { value: "PNG", label: "Papua Nová Guinea" },
            { value: "PRY", label: "Paraguay" },
            { value: "PER", label: "Peru" },
            { value: "PCN", label: "Pitcairn" },
            { value: "CIV", label: "Pobřeží slonoviny" },
            { value: "POL", label: "Polsko" },
            { value: "PRI", label: "Portoriko" },
            { value: "PRT", label: "Portugalsko" },
            { value: "AUT", label: "Rakousko" },
            { value: "REU", label: "Réunion" },
            { value: "GNQ", label: "Rovníková Guinea" },
            { value: "ROU", label: "Rumunsko" },
            { value: "RUS", label: "Rusko" },
            { value: "RWA", label: "Rwanda" },
            { value: "GRC", label: "Řecko" },
            { value: "SPM", label: "Saint Pierre a Miquelon" },
            { value: "SLV", label: "Salvador" },
            { value: "WSM", label: "Samoa" },
            { value: "SMR", label: "San Marino" },
            { value: "SAU", label: "Saúdská Arábie" },
            { value: "SEN", label: "Senegal" },
            { value: "MNP", label: "Severní Mariany" },
            { value: "SYC", label: "Seychely" },
            { value: "SLE", label: "Sierra Leone" },
            { value: "SGP", label: "Singapur" },
            { value: "SVK", label: "Slovensko" },
            { value: "SVN", label: "Slovinsko" },
            { value: "SOM", label: "Somálsko" },
            { value: "ARE", label: "Spojené arabské emiráty" },
            { value: "USA", label: "Spojené státy" },
            { value: "SRB", label: "Srbsko" },
            { value: "CAF", label: "Středoafrická republika" },
            { value: "SDN", label: "Súdán" },
            { value: "SUR", label: "Surinam" },
            { value: "SHN", label: "Svatá Helena" },
            { value: "LCA", label: "Svatá Lucie" },
            { value: "BLM", label: "Svatý Bartoloměj" },
            { value: "KNA", label: "Svatý Kryštof a Nevis" },
            { value: "MAF", label: "Svatý Martin (FR)" },
            { value: "SXM", label: "Svatý Martin (NL)" },
            { value: "STP", label: "Svatý Tomáš a Princův ostrov" },
            { value: "VCT", label: "Svatý Vincenc a Grenadiny" },
            { value: "SWZ", label: "Svazijsko" },
            { value: "SYR", label: "Sýrie" },
            { value: "SLB", label: "Šalomounovy ostrovy" },
            { value: "ESP", label: "Španělsko" },
            { value: "SJM", label: "Špicberky a Jan Mayen" },
            { value: "LKA", label: "Šrí Lanka" },
            { value: "SWE", label: "Švédsko" },
            { value: "CHE", label: "Švýcarsko" },
            { value: "TJK", label: "Tádžikistán" },
            { value: "TZA", label: "Tanzanie" },
            { value: "THA", label: "Thajsko" },
            { value: "TWN", label: "Tchaj-wan" },
            { value: "TGO", label: "Togo" },
            { value: "TKL", label: "Tokelau" },
            { value: "TON", label: "Tonga" },
            { value: "TTO", label: "Trinidad a Tobago" },
            { value: "TUN", label: "Tunisko" },
            { value: "TUR", label: "Turecko" },
            { value: "TKM", label: "Turkmenistán" },
            { value: "TCA", label: "Turks a Caicos" },
            { value: "TUV", label: "Tuvalu" },
            { value: "UGA", label: "Uganda" },
            { value: "UKR", label: "Ukrajina" },
            { value: "URY", label: "Uruguay" },
            { value: "UZB", label: "Uzbekistán" },
            { value: "CXR", label: "Vánoční ostrov" },
            { value: "VUT", label: "Vanuatu" },
            { value: "VAT", label: "Vatikán" },
            { value: "GBR", label: "Velká Británie" },
            { value: "VEN", label: "Venezuela" },
            { value: "VNM", label: "Vietnam" },
            { value: "TLS", label: "Východní Timor" },
            { value: "WLF", label: "Wallis a Futuna" },
            { value: "ZMB", label: "Zambie" },
            { value: "ESH", label: "Západní Sahara" },
            { value: "ZWE", label: "Zimbabwe" },
            ],

        user: {
            id_user: 0,
            degrees_1: "",
            f_name: "",
            l_name: "",
            degrees_2: "",
            phone: "",
            email: "",
            note: "",
            id_dept: null,
            is_doctor: null,
            admin: false,
            editor: false,
        },

        user_default: {
            id_user: 0,
            degrees_1: "",
            f_name: "",
            l_name: "",
            degrees_2: "",
            phone: "",
            email: "",
            note: "",
            id_dept: null,
            is_doctor: null,
            admin: false,
            editor: false,
        },

        users: [],

        pagination_users: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [5, 10, 20, 50, ],
            total: 0
        },

        sorting_users: {
            sorting_prop: "l_name",
            sorting_ordering: "ascending"
        },

        loading_users: false,

        patient: {
            id_patient: null,
            pat_name: "",
            pat_surname: "",
            pat_insu_num: "",
            id_inco: null,
            pat_birth_date: "",
            pat_gender: null,
            pat_street: "",
            pat_street_num: "",
            pat_city: "",
            pat_zip_code: "",
            pat_country: "CZE",
            pat_phone: "",
            pat_email: "",
            pat_public_note: "",
            pat_privat_note: "",
            pat_school: [],

            prvni_priznak_asympt: null,
            prvni_priznak_fokal_deficit: [],
            prvni_priznak_fokal_deficit_jiny_text: "",
            prvni_priznak_epilepsie: "",
            prvni_priznak_epilepsie_jiny_text: "",
            prvni_priznak_nth: false,
            prvni_priznak_ataxie: false,
            prvni_priznak_jiny: false,
            prvni_priznak_jiny_text: "",
            prvni_priznak_del_anam: null,

            syn_pre: null,
            syn_pre_var: null,
            syn_pre_gen: null,
            syn_pre_gen_dal: "",
            ak_st_on: "",
            ak_st_on_pd_dat: "",
            ak_st_on_pd_pr: null,
            ak_st_on_um_dat: "",
            ak_st_on_um_du: "",
            ak_st_on_um_du_jiny: "",
            foll: "",
            prvni_diagnoza: null,
        },

        patient_default: {
            id_patient: null,
            pat_name: "",
            pat_surname: "",
            pat_insu_num: "",
            id_inco: null,
            pat_birth_date: "",
            pat_gender: null,
            pat_street: "",
            pat_street_num: "",
            pat_city: "",
            pat_zip_code: "",
            pat_country: "CZE",
            pat_phone: "",
            pat_email: "",
            pat_public_note: "",
            pat_privat_note: "",
            pat_school: [],

            prvni_priznak_asympt: null,
            prvni_priznak_fokal_deficit: [],
            prvni_priznak_fokal_deficit_jiny_text: "",
            prvni_priznak_epilepsie: "",
            prvni_priznak_epilepsie_jiny_text: "",
            prvni_priznak_nth: false,
            prvni_priznak_ataxie: false,
            prvni_priznak_jiny: false,
            prvni_priznak_jiny_text: "",
            prvni_priznak_del_anam: null,

            syn_pre: null,
            syn_pre_var: null,
            syn_pre_gen: null,
            syn_pre_gen_dal: "",
            ak_st_on: "",
            ak_st_on_pd_dat: "",
            ak_st_on_pd_pr: null,
            ak_st_on_um_dat: "",
            ak_st_on_um_du: "",
            ak_st_on_um_du_jiny: "",
            foll: "",
            prvni_diagnoza: null,
        },

        patient_panel_a1: "",
        patient_panel_a2: "",
        patient_panel_b: "",

        patients: [],

        pagination_patients: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [5, 10, 20, 50, ],
            total: 0
        },

        sorting_patients: {
            sorting_prop: "pat_fullname",
            sorting_ordering: "ascending"
        },

        loading_patients: false,

        patient_tab_active: null,

        filter_select_value: '',

        filter_patients: {
            name: '',
            dat_diag: '',
            diags: null,
            vek_od: null,
            vek_do: null,
        },

        filter_users: '',

        examination: {
            id_examination: null,
            id_patient: null,
            id_operation: null,
            id_checkup: null,
            id_medication: null,
            status: null,
            started: null,
            finished: null,
            published: null,
            description: "",
            public_note: "",

            lansky_skore_p: null,

            ecog_skore_p: null,

            gcs: null,

            pn_lok_str: null,
            pn_lok_topo_prim: null,
            pn_lok_topo_prim_jiny_text: "",
            pn_lok_topo_sir: [],
            pn_lok_topo_sir_jiny_text: "",
            pn_el_zona: null,
            pn_vel_ap: null,
            pn_vel_lat: null,
            pn_vel_kra: null,
            pn_vol: null,
            pn_neuro_str_v: null,
            pn_neuro_str_m: [],
            pn_neuro_str_jiny_text: "",

            dn_prog_rez_text: "",
            dn_lok_rec_text: "",
            dn_dis_met_text: "",
            dn_dupl_text: "",

            on_prim: null,
            ob_nad: [],
            on_d_uk_pro_prog_gr: false,
            on_d_uk_pro_prog_sym: false,
            on_d_uk_pro_pra: false,
            on_d_uk_pro_jiny: false,
            on_d_uk_pro_jiny_text: "",
            on_d_uk: null,

            id_diagnoza: null,
            id_nador: null,
            diagnoza_dat: null,

            vstup_st: null,
            vstup_st_met: null,
            vstup_st_met_rad: "",
            vstup_st_met_intra_text: "",
            vstup_st_met_kan_text: "",
            vstup_st_met_intr_kan_text: "",
            vstup_st_cyt: null,
            vstup_st_cyt_pn: null,
            vstup_st_cyt_p_text: "",
            vstup_st_cha: "",

            mol_ge_snv: null,
            mol_ge_snv_text: "",
            mol_ge_fuze: null,
            mol_ge_fuze_text: "",
            mol_ge_cnv: null,
            mol_ge_cnv_text: "",
            mol_ge_methyl_text: "",

        },

        examination_default: {
            id_examination: null,
            id_patient: null,
            id_operation: null,
            id_checkup: null,
            id_medication: null,
            status: null,
            started: null,
            finished: null,
            published: null,
            description: "",
            public_note: "",

            lansky_skore_p: null,

            ecog_skore_p: null,

            gcs: null,

            pn_lok_str: null,
            pn_lok_topo_prim: null,
            pn_lok_topo_prim_jiny_text: "",
            pn_lok_topo_sir: [],
            pn_lok_topo_sir_jiny_text: "",
            pn_el_zona: null,
            pn_vel_ap: null,
            pn_vel_lat: null,
            pn_vel_kra: null,
            pn_vol: null,
            pn_neuro_str_v: null,
            pn_neuro_str_m: [],
            pn_neuro_str_jiny_text: "",

            dn_prog_rez_text: "",
            dn_lok_rec_text: "",
            dn_dis_met_text: "",
            dn_dupl_text: "",

            on_prim: null,
            ob_nad: [],
            on_d_uk_pro_prog_gr: false,
            on_d_uk_pro_prog_sym: false,
            on_d_uk_pro_pra: false,
            on_d_uk_pro_jiny: false,
            on_d_uk_pro_jiny_text: "",
            on_d_uk: null,

            id_diagnoza: null,
            id_nador: null,
            diagnoza_dat: null,

            vstup_st: null,
            vstup_st_met: null,
            vstup_st_met_rad: "",
            vstup_st_met_intra_text: "",
            vstup_st_met_kan_text: "",
            vstup_st_met_intr_kan_text: "",
            vstup_st_cyt: null,
            vstup_st_cyt_pn: null,
            vstup_st_cyt_p_text: "",
            vstup_st_cha: "",

            mol_ge_snv: null,
            mol_ge_snv_text: "",
            mol_ge_fuze: null,
            mol_ge_fuze_text: "",
            mol_ge_cnv: null,
            mol_ge_cnv_text: "",
            mol_ge_methyl_text: "",

        },

        examinations: [],


        sorting_examinations: {
            sorting_prop: "id_examination",
            sorting_ordering: "descending"
        },

        loading_examinations: false,

        operation: {
            id_operation: null,
            id_patient: null,
            id_examination: null,
            op_dat_oper: null,
            op_biop_ot: false,
            op_biop_ster: false,
            op_biop_free: false,
            op_biop_endo: false,
            op_res: [],
            op_roz_res: null,
            op_pris: "",
            op_elektro: null,
            op_mcs_man_cev: false,
            op_mcs_man_hlav: false,
            op_mcs_zad_jam: false,
            op_mcs_vet: false,
            op_mcs_el: false,
            op_hyd_shu: false,
            op_hyd_ev: false,
            op_hyd_kom: false,
            op_hyd_rev: false,
            op_hyd_jiny: false,
            op_hyd_jiny_text: "",
            op_res_kompl: [],
            op_res_kom_jiny_text: "",
            op_jiny_text: "",
            op_endo: null,
            op_rych_bio: null,
            op_pred_dg: false,

            poo_st: null,
            poo_pro_par: null,
            poo_pro_lhk: false,
            poo_pro_ldk: false,
            poo_pro_phk: false,
            poo_pro_pdk: false,
            poo_nej_def_s: null,
            poo_pro_fa: null,
            poo_pro_fa_ex: false,
            poo_pro_fa_per: false,
            poo_pro_fa_kom: false,
            poo_pro_hl_ner: null,
            poo_pro_hl_ner_s: null,
            poo_pro_sen: null,
            poo_pro_sen_lhk: false,
            poo_pro_sen_ldk: false,
            poo_pro_sen_phk: false,
            poo_pro_sen_pdk: false,
            poo_pro_at: null,
            poo_pro_at_lhk: false,
            poo_pro_at_ldk: false,
            poo_pro_at_phk: false,
            poo_pro_at_pdk: false,
            poo_jiny_text: "",
            poo_pro_ved: null,
            poo_pro_ved_s: null,
            poo_mor: null,
            poo_moz_mu: null,
            poo_delka: null,
            poo_rez_pos: null,

        },

        operation_default: {
            id_operation: null,
            id_patient: null,
            id_examination: null,
            op_dat_oper: null,
            op_biop_ot: false,
            op_biop_ster: false,
            op_biop_free: false,
            op_biop_endo: false,
            op_res: [],
            op_roz_res: null,
            op_pris: "",
            op_elektro: null,
            op_mcs_man_cev: false,
            op_mcs_man_hlav: false,
            op_mcs_zad_jam: false,
            op_mcs_vet: false,
            op_mcs_el: false,
            op_hyd_shu: false,
            op_hyd_ev: false,
            op_hyd_kom: false,
            op_hyd_rev: false,
            op_hyd_jiny: false,
            op_hyd_jiny_text: "",
            op_res_kompl: [],
            op_res_kom_jiny_text: "",
            op_jiny_text: "",
            op_endo: null,
            op_rych_bio: null,
            op_pred_dg: false,

            poo_st: null,
            poo_pro_par: null,
            poo_pro_lhk: false,
            poo_pro_ldk: false,
            poo_pro_phk: false,
            poo_pro_pdk: false,
            poo_nej_def_s: null,
            poo_pro_fa: null,
            poo_pro_fa_ex: false,
            poo_pro_fa_per: false,
            poo_pro_fa_kom: false,
            poo_pro_hl_ner: null,
            poo_pro_hl_ner_s: null,
            poo_pro_sen: null,
            poo_pro_sen_lhk: false,
            poo_pro_sen_ldk: false,
            poo_pro_sen_phk: false,
            poo_pro_sen_pdk: false,
            poo_pro_at: null,
            poo_pro_at_lhk: false,
            poo_pro_at_ldk: false,
            poo_pro_at_phk: false,
            poo_pro_at_pdk: false,
            poo_jiny_text: "",
            poo_pro_ved: null,
            poo_pro_ved_s: null,
            poo_mor: null,
            poo_moz_mu: null,
            poo_delka: null,
            poo_rez_pos: null,

        },

        operations: [],

        sorting_operations: {
            sorting_prop: "id_operation",
            sorting_ordering: "descending"
        },


        loading_operations: false,

        operation_checkups: [],

        checkup: {
            id_checkup: null,
            id_patient: null,
            doctor_id_user: null,
            id_dept: null,
            id_examination: null,
            id_operation: null,
            id_medication: null,
            status: null,
            dt_when: null,
            privat_note: "",
            public_note: "",

        },

        checkup_default: {
            id_checkup: null,
            id_patient: null,
            doctor_id_user: null,
            id_dept: null,
            id_examination: null,
            id_operation: null,
            id_medication: null,
            status: null,
            dt_when: null,
            privat_note: "",
            public_note: "",

        },

        checkups: [],


        sorting_checkups: {
            sorting_prop: "id_checkup",
            sorting_ordering: "descending"
        },

        loading_checkups: false,

        medication: {
            id_medication: null,
            id_patient: null,
            id_examination: null,
            id_operation: null,
            id_checkup: null,
            klin_st: null,
            id_med_cis_protokol: null,
            chem_int: null,
            chem_int_z: null,
            chem_int_k: null,
            chem_int_cyt: [],
            chem_int_kom: null,
            chem_int_kom_dr: [],
            chem_int_re_cyt: null,
            chem_int_inthe_ter: null,
            chem_int_inthe_ter_cyt: null,
            chem_int_inver_ter: null,
            chem_int_inver_ter_cyt: null,

            udr_chem: null,
            udr_chem_z: null,
            udr_chem_k: null,
            udr_chem_text: "",
            udr_chem_kom: null,
            udr_chem_kom_dr: [],
            udr_chem_kom_st: [],
            udr_chem_re_cyt: null,
            udr_chem_inthe_ter: null,
            udr_chem_inthe_ter_cyt: null,
            udr_chem_inver_ter: null,
            udr_chem_inver_ter_cyt: null,

            bio_ter: [],
            bio_ter_z: null,
            bio_ter_k: null,
            bio_ter_lek: [],
            bio_ter_kom: null,
            bio_ter_kom_dr: [],
            bio_ter_kom_st: [],
            bio_ter_re: null,

            rad: null,
            rad_typ: null,
            rad_z: null,
            rad_op: null,
            rad_op_od: null,
            rad_k: null,
            rad_roz: null,
            rad_dav_kra: null,
            rad_dav_tum: null,
            rad_dav_met: null,
            rad_kom: null,
            rad_kom_dr: [],
            rad_kom_st: [],
            rad_kom_od: null,
            rad_kom_dat: null,
            rad_kom_do: null,
            rad_nekr: null,
            rad_nekr_kl: null,
            rad_od: null,

            stav_kon: null,

            poznamka: "",

        },

        medication_default: {
            id_medication: null,
            id_patient: null,
            id_examination: null,
            id_operation: null,
            id_checkup: null,
            klin_st: null,
            id_med_cis_protokol: null,
            chem_int: null,
            chem_int_z: null,
            chem_int_k: null,
            chem_int_cyt: [],
            chem_int_kom: null,
            chem_int_kom_dr: [],
            chem_int_re_cyt: null,
            chem_int_inthe_ter: null,
            chem_int_inthe_ter_cyt: null,
            chem_int_inver_ter: null,
            chem_int_inver_ter_cyt: null,

            udr_chem: null,
            udr_chem_z: null,
            udr_chem_k: null,
            udr_chem_text: "",
            udr_chem_kom: null,
            udr_chem_kom_dr: [],
            udr_chem_kom_st: [],
            udr_chem_re_cyt: null,
            udr_chem_inthe_ter: null,
            udr_chem_inthe_ter_cyt: null,
            udr_chem_inver_ter: null,
            udr_chem_inver_ter_cyt: null,

            bio_ter: null,
            bio_ter_z: null,
            bio_ter_k: null,
            bio_ter_lek: [],
            bio_ter_kom: null,
            bio_ter_kom_dr: [],
            bio_ter_kom_st: [],
            bio_ter_ter_re: null,
            bio_ter_re: null,

            rad: null,
            rad_typ: null,
            rad_z: null,
            rad_op: null,
            rad_op_od: null,
            rad_k: null,
            rad_roz: null,
            rad_dav_kra: null,
            rad_dav_tum: null,
            rad_dav_met: null,
            rad_kom: null,
            rad_kom_dr: [],
            rad_kom_st: [],
            rad_kom_od: null,
            rad_kom_dat: null,
            rad_kom_do: null,
            rad_nekr: null,
            rad_nekr_kl: null,
            rad_od: null,

            stav_kon: null,

            poznamka: "",
        },

        medications: [],


        sorting_medications: {
            sorting_prop: "id_medication",
            sorting_ordering: "descending"
        },

        loading_medications: false,

        dashboard: {
            id_dashboard: 0,

        },

        dashboard_default: {
            id_dashboard: 0,

        },

        dashboards: [],


        sorting_dashboards: {
            sorting_prop: "id_dashboard",
            sorting_ordering: "descending"
        },

        loading_dashboards: false,


        pat_ak_st_on_um_du_v: [
            'Died of disease',
            'Died of complications',
            'jiný',
         ],

        pat_vek_v: [
            '< 1',
            '1 - 5',
            '5 - 10',
            '10 - 15',
            '> 15',
        ],

        l_pat_cis_syn_pre_var: [],

        l_pat_cis_syn_pre_gen: [],
        sorting_pat_cis_syn_pre_gen: {
            sorting_prop: "nazev_gen",
            sorting_ordering: "ascending"
        },

        l_pat_cis_prv_priz_fok_def: [],

        l_insurance_companies: [],


        sorting_incos: {
            sorting_prop: "inco_name",
            sorting_ordering: "ascending"
        },

        l_pat_skola: [],
        skoly: [],

        l_op_cis_res_kompl: [],
        op_komplikace: [],

        nth_gcs: [
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            '13',
            '14',
            '15',
        ],

        lansky_skore: [
            '0',
            '10',
            '20',
            '30',
            '40',
            '50',
            '60',
            '70',
            '80',
            '90',
            '100',
        ],

        ecog_skore: [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
        ],


        pn_neuro_str_pos: [
            'aci',
            'oftalmika',
            'pcom',
            'aca',
            'acom',
            'mca',
            'va',
            'ba',
            'pica',
            'sca',
            'aica',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
            'jiný',
        ],

        ob_nad_vycet: [
            'Primární diagnóza',
            'Recidiva onemocnění',
            'Nádorová duplicita',
        ],

        l_exam_diagnozy: [],

        l_diags: [],

        l_diag_groups: [],

        d_diag_groups: {},

        l_cis_diags: [],

        l_med_cis_chem_int_cyt: [],

        l_med_cis_kompl_dr: [],
        med_komplikace: [],

        l_exam_cis_sk_nadoru: [],

        l_exam_cis_pn_lok_topo_prim: [],

        sorting_lok_topo_prims: {
            sorting_prop: "nazev_pn_lok_topo_prim",
            sorting_ordering: "ascending"
        },

        l_check_cis_dept: [],

        op_resekce: [
            'primární nádor',
            'časné reziduum',
            'progrese rezidua',
            'lokální recidiva',
            'distant metastaza',
            'duplicita',
        ],

        op_roz_resekce: [
            'STR - vše menší',
            'NTR - nálety/film 99%',
            'GTR - radikálně',
        ],

        // op_res_komplikaci: [
        //     { value: 'hematom', label: 'hematom',
        //         children: [
        //             { value: 'edh', label: 'edh' },
        //             { value: 'sdh', label: 'sdh' },
        //             { value: 'ich/dutina', label: 'ich/dutina' },
        //             { value: 'jiný', label: 'jiný' },
        //         ]
        //     },
        //     { value: 'ischemie', label: 'ischemie',
        //         children: [
        //             { value: 'ano', label: 'ano' },
        //             { value: 'ne', label: 'ne' },
        //         ]
        //     },
        //     { value: 'dekomprese', label: 'dekomprese',
        //         children: [
        //             { value: 'ano', label: 'ano' },
        //             { value: 'ne', label: 'ne' },
        //         ]
        //     },
        //     { value: 'infekce', label: 'infekce',
        //         children: [
        //             { value: 'ano', label: 'ano' },
        //             { value: 'ne', label: 'ne' },
        //         ]
        //     },
        //     { value: 'rána', label: 'rána',
        //         children: [
        //             { value: 'ano', label: 'ano' },
        //             { value: 'ne', label: 'ne' },
        //         ]
        //     },
        // ],

        op_endoskop: [
            { value: 'ne', label: 'ne' },
            { value: 'primárně', label: 'primárně' },
            { value: 'assisted', label: 'assisted' },
            { value: 'konverze', label: 'konverze' },
        ],

        poo_mrs: [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
        ],

        poo_pro_hl_nerv: [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
        ],

        pat_cis_prv_priz_fok_def: [],

        pat_cis_syn_pre_var: [],

        pat_cis_syn_pre_gen: [],

        med_cis_protokol: [],

        l_med_cis_chem_int_inthe_inver_cyt: [],

        l_med_cis_udr_chem_inthe_inver_cyt: [],

        exam_cis_diag_groups: [],

        exam_cis_diags: [],

        med_bio_ter_kom_dr_v: [
            'klm',
            'nop',
            'rst',
        ],

        med_bio_ter_kom_st_v: [
            '1',
            '2',
            '3',
            '4',
        ],


        l_med_cis_bio_ter_lek: [],

        med_rad_roz_v: [
            'fokální',
            'kraniospinální',
        ],

        med_rad_kom_dr_v: [
            'klm',
            'nop',
            'rst',
        ],

        med_rad_kom_st_v: [
            '1',
            '2',
            '3',
            '4',
        ],

        med_rad_kom_od_v: [
            'akutní',
            'subakutní',
            'chronické',
        ],

        med_rad_typ_v: [
            'fotonová radioterapie',
            'protonová radioterapie',
            'stereoradiochirurgie',
            'brachyradioterapie'
        ],

        reviews: [],

        sorting_reviews: {
            sorting_prop: "id_review",
            sorting_ordering: "descending"
        },


        loading_reviews: false,

        l_depts: [],

        loading_ad_settings: false,


    },


    getters: {
        // g_med_cis_protokol: (state, getters) => {
        //     var val = [];
        //     for (var one of state.med_cis_protokol) {
        //         val.push(one.nazev_protokol);
        //     }
        //     return val;
        // },



        // g_med_cis_chem_int_inthe_inver_cyt: (state, getters) => {
        //     var val = [];
        //     for (var one of state.l_med_cis_chem_int_inthe_inver_cyt) {
        //         val.push(one.med_cis_chem_int_inthe_inver_cyt);
        //     }
        //     return val;
        // },


        // g_med_cis_udr_chem_inthe_inver_cyt: (state, getters) => {
        //     var val = [];
        //     for (var one of state.l_med_cis_udr_chem_inthe_inver_cyt) {
        //         val.push(one.med_cis_udr_chem_inthe_inver_cyt);
        //     }
        //     return val;
        // },


        g_patient_insurance_company: (state, getters) => {
            if (parseInt(state.patient.id_inco) > 0) {
                return state.l_insurance_companies.filter(one => (one.id_inco === state.patient.id_inco))[0];
            } else {
                return "---"
            }
        },


        g_exam_diagnozy: (state, getters) => (id_diag) => {
            if (id_diag > 0) {
                return state.l_exam_diagnozy.filter(one => (one.id_diagnoza === id_diag))[0]["diagnoza_nazev"];
            } else {
                return "---"
            }
        },


        g_l_doctors: (state, getters) => (id_dept) => {
            if (id_dept > 0) {
                return state.users.filter(one => (one.id_dept === id_dept));
            } else {
                return []
            }
        },

    },


    mutations: {
        m_modal_login(state, value) {
            state.modal_login = value;
        },

        m_modal_reg(state, value) {
            state.modal_reg = value;
        },


        m_modal_password_new(state, value) {
            state.modal_password_new = value;
        },


        m_modal_password_change(state, value) {
            state.modal_password_change = value;
        },

        m_modal_password_forgot(state, value) {
            state.modal_password_forgot = value;
        },

        m_modal_help(state, value) {
            state.modal_help = value;
        },

        m_modal_info(state, value) {
            state.modal_info = value;
        },

        m_modal_info_text(state, value) {
            state.modal_info_text = value;
            if (state.modal_info_text > '') {
                state.modal_info = true
            } else {
                state.modal_info = false
            }
        },

        m_application(state, value) {
            state.application = value;
        },

        m_current_url(state, value) {
            state.current_url = value;
        },

        m_loading_ad_settings(state, value) {
            state.loading_ad_settings = value;
        },


        m_modal_user(state, value) {
            state.modal_user = value;
        },

        m_modal_user_ro(state, value) {
            state.modal_user_ro = value;
        },

        m_modal_patient(state, value) {
            state.modal_patient = value;
        },

        m_modal_patient_ro(state, value) {
            state.modal_patient_ro = value;
        },

        m_modal_checkup(state, value) {
            state.modal_checkup = value;
        },

        m_modal_checkup_ro(state, value) {
            state.modal_checkup_ro = value;
        },

        m_modal_examination(state, value) {
            state.modal_examination = value;
        },

        m_modal_examination_ro(state, value) {
            state.modal_examination_ro = value;
        },

        m_modal_operation(state, value) {
            state.modal_operation = value;
        },

        m_modal_operation_ro(state, value) {
            state.modal_operation_ro = value;
        },

        m_modal_medication(state, value) {
            state.modal_medication = value;
        },

        m_modal_medication_ro(state, value) {
            state.modal_medication_ro = value;
        },

        m_modal_dashboard(state, value) {
            state.modal_dashboard = value;
        },

        m_token(state, value) {
            state.token = value;
        },

        m_id_user(state, value) {
            state.id_user = value;
        },

        m_login(state, { email, password }) {

        },

        m_subject(state, value) {
            state.subject = value;
        },

        m_user(state, value) {
            state.user = value;
        },


        m_loginuser(state, value) {
            state.loginuser = value;
            state.modal_user_ro = !value.editor;
            state.modal_patient_ro = !value.editor;
            state.modal_checkup_ro = !value.editor;
            state.modal_examination_ro = !value.editor;
            state.modal_operation_ro = !value.editor;
            state.modal_medication_ro = !value.editor;
        },

        m_users(state, value) {
            state.users = value;
        },

        m_user_reset(state) {
            Object.assign(state.user, state.user_default);
        },

        m_user_item(state, { mykey, value }) {
            state.user[mykey] = value;
        },

        m_user_id(state, value) {
            state.user.id_user = value;
        },

        m_filter_users(state, value) {
            state.filter_users = value;
        },

        m_dashboard(state, value) {
            state.dashboard = value;
        },

        m_dashboards(state, value) {
            state.dashboards = value;
        },

        m_dashboard_reset(state) {
            Object.assign(state.dashboard, state.dashboard_default);
        },

        m_dashboard_item(state, { mykey, value }) {
            state.dashboard[mykey] = value;
        },

        m_dashboard_id(state, value) {
            state.dashboard.id_dashboard = value;
        },

        m_patients(state, value) {
            state.patients = value;
        },

        m_patient(state, value) {
            Object.assign(state.patient, state.patient_default);
            Object.assign(state.patient, value);
        },

        m_patient_panel_a1(state, value) {
            state.patient_panel_a1 = value;
        },

        m_patient_panel_a2(state, value) {
            state.patient_panel_a2 = value;
        },

        m_patient_panel_b(state, value) {
            state.patient_panel_b = value;
        },


        m_patient_reset(state) {
            Object.assign(state.patient, state.patient_default);
        },

        m_patient_item(state, { mykey, value }) {
            state.patient[mykey] = value;
        },

        m_patient_id(state, value) {
            state.patient.id_patient = value;
        },

        m_patient_tab_active(state, value) {
            state.patient_tab_active = value;
        },

        m_filter_select_value(state, value) {
            state.filter_select_value = value;
        },

        m_patient_pat_birth_date(state, payload) {
            let bida = new Date(payload.xyy, payload.xmm, payload.xdd);
            state.patient.pat_birth_date = moment(bida).format("YYYY-MM-DD");
        },

        m_patient_pat_gender(state, value) {
            state.patient.pat_gender = value;
        },


        m_examinations(state, value) {
            state.examinations = value;
        },

        m_examination(state, value) {
            state.examination = value;
        },

        m_examination_reset(state) {
            Object.assign(state.examination, state.examination_default);
        },

        m_examination_by_key(state, { mykey, value }) {
            state.examination[mykey] = value;
        },

        m_operations(state, value) {
            state.operations = value;
        },

        m_operation(state, value) {
            state.operation = value;
        },

        m_operation_reset(state) {
            Object.assign(state.operation, state.operation_default);
        },

        m_operation_by_key(state, { mykey, value }) {
            state.operation[mykey] = value;
        },

        m_checkups(state, value) {
            state.checkups = value;
        },

        m_checkup(state, value) {
            state.checkup = value;
        },

        m_checkup_reset(state) {
            Object.assign(state.checkup, state.checkup_default);
        },

        m_checkup_item(state, { mykey, value }) {
            state.checkup[mykey] = value;
        },

        m_checkup_by_key(state, { mykey, value }) {
            state.checkup[mykey] = value;
        },

        m_medications(state, value) {
            state.medications = value;
        },

        m_medication(state, value) {
            state.medication = value;
        },

        m_medication_reset(state) {
            Object.assign(state.medication, state.medication_default);
        },

        m_medication_by_key(state, { mykey, value }) {
            state.medication[mykey] = value;
        },

        m_l_insurance_companies(state, value) {
            state.l_insurance_companies = value;
        },

        m_l_depts(state, value) {
            state.l_depts = value;
        },

        m_l_exam_diagnozy(state, value) {
            state.l_exam_diagnozy = value;
        },

        m_l_diags(state, value) {
            state.l_diags = value;
        },

        m_pat_cis_syn_pre_var(state, value) {
            state.l_pat_cis_syn_pre_var = value;
        },

        m_pat_cis_syn_pre_gen(state, value) {
            state.l_pat_cis_syn_pre_gen = value;
        },

        m_pat_cis_prv_priz_fok_def(state, value) {
            state.l_pat_cis_prv_priz_fok_def = value;
        },

        m_pat_skola(state, value) {
            state.l_pat_skola = value;
        },

        m_skoly(state, value) {
            state.skoly = value;
        },

        m_op_cis_res_kompl(state, value) {
            state.l_op_cis_res_kompl = value;
        },

        m_op_komplikace(state, value) {
            state.op_komplikace = value;
        },

        m_med_cis_bio_ter_lek(state, value) {
            state.l_med_cis_bio_ter_lek = value;
        },

        m_med_cis_chem_int_cyt(state, value) {
            state.l_med_cis_chem_int_cyt = value;
        },

        m_med_cis_chem_int_inthe_inver_cyt(state, value) {
            state.l_med_cis_chem_int_inthe_inver_cyt = value;
        },

        m_med_cis_udr_chem_inthe_inver_cyt(state, value) {
            state.l_med_cis_udr_chem_inthe_inver_cyt = value;
        },

        m_med_cis_protokol(state, value) {
            state.med_cis_protokol = value;
        },

        m_med_cis_kompl_dr(state, value) {
            state.l_med_cis_kompl_dr = value;
        },

        m_med_komplikace(state, value) {
            state.med_komplikace = value;
        },

        m_exam_cis_diag_groups(state, value) {
            state.exam_cis_diag_groups = value;
        },

        m_exam_cis_diags(state, value) {
            state.exam_cis_diags = value;
        },

        m_reviews(state, value) {
            state.reviews = value;
        },

        m_l_diag_groups(state, value) {
            state.l_diag_groups = value;
        },

        m_d_diag_groups(state, value) {
            state.d_diag_groups = value;
        },

        m_l_cis_diags(state, value) {
            state.l_cis_diags = value;
        },

        m_l_exam_cis_sk_nadoru(state, value) {
            state.l_exam_cis_sk_nadoru = value;
        },

        m_exam_cis_pn_lok_topo_prim(state, value) {
            state.l_exam_cis_pn_lok_topo_prim = value;
        },

        m_check_cis_dept(state, value) {
            state.l_check_cis_dept = value;
        },

    },


    actions: {
        a_notify(context, payload) {
            notifier.$notify(payload);
        },


        a_help({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/help', {"form_help": payload}, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_modal_help', false);
                    this.dispatch('a_notify', { message: 'Dotaz byl úspěšně odeslán.', }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', { message: 'Dotaz NEBYL odeslán. Zopakujte akci později.', }, { root: true });
                });

        },


        a_login({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/login', payload, { withCredentials: true, headers: { 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_token', response.data["token"]);
                    if (response.data["token"]) {
                        localStorage.setItem('token', response.data["token"]);
                        commit('m_modal_login', false);
                        commit('m_loginuser', response.data["user"]);
                    } else {
                        commit('m_modal_login', false);
                        commit('m_modal_info_text', "Zadané údaje neodpovídají platnému účtu. Zkuste to, prosím, znovu.");
                    }
                }, error => {
                    console.log(error);
                });

        },


        a_logout({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/logout', { headers: { 'Authorization': state.token } }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_token', "");
                    localStorage.removeItem("token");
                }, error => {
                    console.log(error);
                });

            console.log("Logout");
            router.push("/");
        },



        a_login_hash({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/login', { params: payload, withCredentials: true, headers: { 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    if (response.data["token"]) {
                        commit('m_modal_password_forgot', false);
                        commit('m_loginuser', response.data["user"]);
                        commit('m_token', response.data["token"]);
                        localStorage.setItem('token', response.data["token"]);
                        commit('m_modal_password_new', true);
                    }
                }, error => {
                    console.log(error);
                });

        },


        a_forgot({ state, commit, getters }, payload) {
            axios.patch(process.env.VUE_APP_BE + '/login', payload, { withCredentials: true, headers: { 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_modal_password_forgot', false);
                    this.dispatch('a_notify', { message: 'Na váš e-mail byly zaslány pokyny k přihlášení.', }, { root: true });
                }, error => {
                    console.log(error);
                });

        },


        a_password_change({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/login', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_notify', { message: 'Heslo bylo změněno.', }, { root: true });
                }, error => {
                    this.dispatch('a_notify', { message: 'Heslo NEŠLO změnit.', }, { root: true });
                    console.log(error);
                });
        },


        a_reg({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/registration', { email: payload.email, password: payload.password, degrees_1: payload.degrees_1, firstName: payload.firstName, lastName: payload.lastName, degrees_2: payload.degrees_2, phone: payload.phone }, { withCredentials: true, headers: { 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    if (response.data["status"] === "OK") {
                        commit('m_modal_reg', false);
                        commit('m_modal_info_text', "Děkujeme za registraci. Posíláme Vám email s ověřovacím odkazem pro aktivaci Vašeho účtu.");

                    } else {
                        commit('m_modal_reg', false);
                        commit('m_modal_info_text', "Zadané údaje neodpovídají platnému účtu. Zkuste to, prosím, znovu.");
                    }
                }, error => {
                    console.log(error);
                });

        },


        a_load_profile({ state, commit }, payload) {
            axios.get(process.env.VUE_APP_BE + '/load_profile', { headers: { 'Authorization': state.token } }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_loginuser', response.data["user"]);

                }, error => {
                    console.log(error);
                });
        },



        a_users({ state, commit } ) {
            state.loading_users = true;
            let payload = {...state.pagination_users, ...state.sorting_users};
            payload["filter_users"] = state.filter_users;

            axios.get(process.env.VUE_APP_BE + '/users', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_users', response.data["users"]);
                    state.pagination_users.total = response.data["total"];
                    state.loading_users = false;
                }, error => {
                    console.log(error);
                    state.loading_users = false;
                });
        },


        a_user({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/user', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_user', response.data["user"]);
                }, error => {
                    console.log(error);
                });
        },


        a_user_new({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/users', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    let xxx = {...state.pagination_users, ...state.sorting_users};
                    xxx["filter_users"] = state.filter_users;

                    this.dispatch('a_users', xxx);
                    this.dispatch('a_notify', {
                        message: 'Nový uživatel byl přidán',
                    }, { root: true });
                }, error => {
                    if (error.response.status === 400) {
                        this.dispatch('a_notify', { message: 'Uživatele nelze přidat, e-mail již existuje.', }, { root: true });
                    } else if (error.response.status === 404) {
                        this.dispatch('a_notify', { message: 'Přidání uživatele nebylo provedeno. E-mail pravděpodobně neexistuje.', }, { root: true });
                    } else {
                        this.dispatch('a_notify', { message: 'Uživatele nelze přidat.', }, { root: true });
                    }
                    console.log(error);
                });
        },


        a_user_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/user', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    let xxx = {...state.pagination_users, ...state.sorting_users};
                    xxx["filter_users"] = state.filter_users;

                    this.dispatch('a_load_profile');
                    this.dispatch('a_users', xxx);
                    this.dispatch('a_notify', { message: 'Změna u uživatele byla provedena.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_user_delete({ state, commit, dispatch }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/user', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_users', { id_user: state.user.id_user });
                    this.dispatch('a_notify', { message: 'Uživatel byl smazán.', }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', { message: 'Uživatel nelze smazat.', }, { root: true });
                });
        },


        a_patients({ state, commit } ) {
            state.loading_patients = true;
            let payload = {...state.pagination_patients, ...state.sorting_patients};
            payload["fp_name"] = state.filter_patients.name;
            payload["fp_dat_diag"] = state.filter_patients.dat_diag;
            payload["fp_diags"] = state.filter_patients.diags;
            payload["fp_vek_od"] = state.filter_patients.vek_od;
            payload["fp_vek_do"] = state.filter_patients.vek_do;
            axios.get(process.env.VUE_APP_BE + '/patients', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_patients', response.data["patients"]);
                    state.pagination_patients.total = response.data["total"];

                    this.dispatch('a_pat_cis_syn_pre_var', {});
                    this.dispatch('a_pat_cis_syn_pre_gen', {});
                    this.dispatch('a_pat_skola', {});

                    this.dispatch('a_exam_cis_pn_lok_topo_prim', {});
                    this.dispatch('a_exam_cis_diag_groups_get', {});
                    this.dispatch('a_exam_cis_diags_get', {});

                    this.dispatch('a_op_cis_res_kompl', {});

                    this.dispatch('a_med_cis_chem_int_cyt', {});
                    this.dispatch('a_med_cis_kompl_dr', {});
                    this.dispatch('a_med_cis_bio_ter_lek', {});

                    this.dispatch('a_check_cis_dept', {});

                    state.loading_patients = false;
                }, error => {
                    console.log(error);
                    state.loading_patients = false;
                });
        },


        a_patient({ state, commit, getters, dispatch }, payload) {
            axios.get(process.env.VUE_APP_BE + '/patient', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_patient', response.data["patient"]);
                    commit('m_patient_panel_a1', response.data["patient_panel_a1"]);
                    commit('m_patient_panel_a2', response.data["patient_panel_a2"]);
                    commit('m_patient_panel_b', response.data["patient_panel_b"]);

                }, error => {
                    console.log(error);
                });
        },


        a_patient_new({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/patients', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_patients', {});
                    this.dispatch('a_notify', {
                        message: 'Nový pacient byl přidán',
                    }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_patient_update({ state, commit, dispatch }, payload) {
            console.log(payload);
            axios.put(process.env.VUE_APP_BE + '/patient', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_patients', {});
                    this.dispatch('a_notify', { message: 'Změna byla provedena.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_patient_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/patient', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    if (response.data["status"] > 0) {
                        this.dispatch('a_patients', {});
                        commit('m_examinations', []);
                        this.dispatch('a_notify', { message: 'Pacient byl smazán.', }, { root: true });

                    } else {
                        this.dispatch('a_notify', { message: 'Pacient nemůže být smazán.', }, { root: true });
                    }
                }, error => {
                    console.log(error);
                });
        },


        a_dashboards({ state, commit } ) {
            state.loading_dashboards = true;
            let payload = {...state.sorting_dashboards};
            axios.get(process.env.VUE_APP_BE + '/dashboards', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_dashboards', response.data["dashboards"]);
                    state.loading_dashboards = false;
                }, error => {
                    console.log(error);
                    state.loading_dashboards = false;
                });
        },


        a_dashboard({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/dashboard', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_dashboard', response.data["dashboard"]);

                }, error => {
                    console.log(error);
                });
        },


        a_dashboard_new({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/dashboards', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_dashboards', {});
                    this.dispatch('a_notify', { message: 'Nový přehled byl přidán', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_dashboard_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/dashboard', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_dashboards', {});
                    this.dispatch('a_notify', { message: 'Změna byla provedena.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_examinations({ state, commit } ) {
            state.loading_examinations = true;
            let payload = { ...state.sorting_examinations};
            payload["id_patient"] = state.patient.id_patient;
            axios.get(process.env.VUE_APP_BE + '/examinations', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_examinations', response.data["examinations"]);
                    state.loading_examinations = false;
                }, error => {
                    console.log(error);
                    state.loading_examinations = false;
                });
            console.log(state.patients);
        },


        a_examination({ state, commit }, payload) {
            axios.get(process.env.VUE_APP_BE + '/examination', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_examination', response.data["examination"]);
                    console.log(response.data["examination"]);

                }, error => {
                    console.log(error);
                });
        },


        a_examination_new({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/examinations', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_examinations', {});
                    this.dispatch('a_patients', {});
                    this.dispatch('a_patient', state.patient);

                    this.dispatch('a_notify', { message: 'Nová událost byla přidána', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_examination_update({ state, commit, dispatch }, payload) {
            console.log(payload);
            axios.put(process.env.VUE_APP_BE + '/examination', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_examinations', {});
                    this.dispatch('a_patients', {});
                    this.dispatch('a_patient', state.patient);
                    this.dispatch('a_notify', { message: 'Změna byla provedena', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_examination_delete({ state, commit, dispatch }, payload) {
          axios.delete(process.env.VUE_APP_BE + '/examination', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
          .then(response => {
            this.dispatch('a_examinations', {});
            this.dispatch('a_patients', {});
            this.dispatch('a_patient', state.patient);
            this.dispatch('a_notify', { message: 'Událost byla smazána', }, { root: true });
          }, error => {
              console.log(error);
              this.dispatch('a_notify', { message: 'Událost nemůže být smazána', }, { root: true });
          });
        },


        a_checkups({ state, commit } ) {
            state.loading_checkups = true;
            let payload = { ...state.sorting_checkups};
            payload["id_patient"] = state.patient.id_patient;

            axios.get(process.env.VUE_APP_BE + '/checkups', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_checkups', response.data["checkups"]);
                    state.loading_checkups = false;
                }, error => {
                    console.log(error);
                    state.loading_checkups = false;
                });
        },


        a_checkup({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/checkup', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_checkup', response.data["checkup"]);

                }, error => {
                    console.log(error);
                });
        },


        a_checkup_new({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/checkups', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_checkups', {id_patient: state.patient.id_patient});
                    this.dispatch('a_patient', state.patient);
                    this.dispatch('a_notify', { message: 'Nový termín vyšetření byl přidán', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_checkup_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/checkup', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_checkups', {id_patient: state.patient.id_patient});
                    this.dispatch('a_patient', state.patient);
                    this.dispatch('a_notify', { message: 'Změna byla provedena.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_checkup_delete({ state, commit, dispatch }, payload) {
          axios.delete(process.env.VUE_APP_BE + '/checkup', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
          .then(response => {
            this.dispatch('a_checkups', {});
            this.dispatch('a_patients', {});
            this.dispatch('a_patient', state.patient);
            this.dispatch('a_notify', { message: 'Kontrola byla smazána', }, { root: true });
          }, error => {
              console.log(error);
              this.dispatch('a_notify', { message: 'Kontrola nemůže být smazána', }, { root: true });
          });
        },


        a_operations({ state, commit } ) {
            state.loading_operations = true;
            let payload = { ...state.sorting_operations};
            payload["id_patient"] = state.patient.id_patient;
            axios.get(process.env.VUE_APP_BE + '/operations', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_operations', response.data["operations"]);
                    state.loading_operations = false;
                }, error => {
                    console.log(error);
                    state.loading_operations = false;
                });
        },


        a_operation({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/operation', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_operation', response.data["operation"]);

                }, error => {
                    console.log(error);
                });
        },


        a_operation_new({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/operations', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_operations', {});
                    this.dispatch('a_patient', state.patient);
                    this.dispatch('a_notify', { message: 'Nová operace byla přidána', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_operation_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/operation', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_operations', {id_patient: state.patient.id_patient});
                    this.dispatch('a_patient', state.patient);
                    this.dispatch('a_notify', { message: 'Změna byla provedena.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_operation_delete({ state, commit, dispatch }, payload) {
          axios.delete(process.env.VUE_APP_BE + '/operation', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
          .then(response => {
            this.dispatch('a_operations', {});
            this.dispatch('a_patients', {});
            this.dispatch('a_patient', state.patient);
            this.dispatch('a_notify', { message: 'Operace byla smazána', }, { root: true });
          }, error => {
              console.log(error);
              this.dispatch('a_notify', { message: 'Operace nemůže být smazána', }, { root: true });
          });
        },


        a_medications({ state, commit } ) {
            state.loading_medications = true;
            let payload = {...state.sorting_medications};
            payload["id_patient"] = state.patient.id_patient;

            this.dispatch('a_med_cis_protokol', {});

            axios.get(process.env.VUE_APP_BE + '/medications', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_medications', response.data["medications"]);
                    state.loading_medications = false;
                }, error => {
                    console.log(error);
                    state.loading_medications = false;
                });
        },


        a_medication({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/medication', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_medication', response.data["medication"]);

                }, error => {
                    console.log(error);
                });
        },


        a_medication_new({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/medications', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_medications', {});
                    this.dispatch('a_patient', state.patient);
                    this.dispatch('a_notify', { message: 'Nová léčba byla přidána', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_medication_update({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/medication', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_medications', {id_patient: state.patient.id_patient});
                    this.dispatch('a_patient', state.patient);
                    this.dispatch('a_notify', { message: 'Změna byla provedena.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_medication_delete({ state, commit, dispatch }, payload) {
          axios.delete(process.env.VUE_APP_BE + '/medication', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
          .then(response => {
            this.dispatch('a_medications', {});
            this.dispatch('a_patients', {});
            this.dispatch('a_patient', state.patient);
            this.dispatch('a_notify', { message: 'Léčba byla smazána', }, { root: true });
          }, error => {
              console.log(error);
              this.dispatch('a_notify', { message: 'Léčba nemůže být smazána', }, { root: true });
          });
        },


        a_pat_cis_syn_pre_var({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_pat_cis_syn_pre_var', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_pat_cis_syn_pre_var', response.data["l_pat_cis_syn_pre_var"]);

                }, error => {
                    console.log(error);
                });
        },


        a_pat_cis_syn_pre_var_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_pat_cis_syn_pre_var', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_cis_syn_pre_var', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_pat_cis_syn_pre_var_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_pat_cis_syn_pre_var', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_cis_syn_pre_var', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_pat_cis_syn_pre_var_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_pat_cis_syn_pre_var', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_cis_syn_pre_var', {});
                    this.dispatch('a_notify', {
                        message: 'Položka byla smazána.',
                    }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', {
                        message: 'Položka je již použita a nemůže být smazána',
                    }, { root: true });
                });
        },


        a_pat_cis_syn_pre_gen({ state, commit }, ) {
            let payload = { ...state.sorting_pat_cis_syn_pre_gen};
            axios.get(process.env.VUE_APP_BE + '/l_pat_cis_syn_pre_gen', { params: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_pat_cis_syn_pre_gen', response.data["l_pat_cis_syn_pre_gen"]);

                }, error => {
                    console.log(error);
                });
        },


        a_pat_cis_syn_pre_gen_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_pat_cis_syn_pre_gen', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_cis_syn_pre_gen', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_pat_cis_syn_pre_gen_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_pat_cis_syn_pre_gen', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_cis_syn_pre_gen', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_pat_cis_syn_pre_gen_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_pat_cis_syn_pre_gen', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_cis_syn_pre_gen', {});
                    this.dispatch('a_notify', { message: 'Položka byla smazána.', }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', { message: 'Položka je již použita a nemůže být smazána', }, { root: true });
                });
        },


        a_pat_cis_prv_priz_fok_def({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_pat_cis_prv_priz_fok_def', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_pat_cis_prv_priz_fok_def', response.data["l_pat_cis_prv_priz_fok_def"]);

                }, error => {
                    console.log(error);
                });
        },


        a_pat_cis_prv_priz_fok_def_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_pat_cis_prv_priz_fok_def', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_cis_prv_priz_fok_def', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_pat_cis_prv_priz_fok_def_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_pat_cis_prv_priz_fok_def', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_cis_prv_priz_fok_def', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_pat_cis_prv_priz_fok_def_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_pat_cis_prv_priz_fok_def', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_cis_prv_priz_fok_def', {});
                    this.dispatch('a_notify', {
                        message: 'Položka byla smazána.',
                    }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', {
                        message: 'Položka je již použita a nemůže být smazána',
                    }, { root: true });
                });
        },


        a_pat_skola({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_pat_skola', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_pat_skola', response.data["l_pat_skola"]);
                    commit('m_skoly', response.data["skoly"]);

                }, error => {
                    console.log(error);
                });
        },


        a_pat_skola_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_pat_skola', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_skola', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_pat_skola_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_pat_skola', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_skola', {});
                    this.dispatch('a_notify', { message: 'Položka byla smazána.', }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', { message: 'Položka je již použita a nemůže být smazána', }, { root: true });
                });
        },


        a_pat_insurance_companies({ state, commit }, ) {
            let payload = {...state.sorting_incos};
            axios.get(process.env.VUE_APP_BE + '/l_insurance_companies', { params: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_l_insurance_companies', response.data["l_insurance_companies"]);

                }, error => {
                    console.log(error);
                });
        },


        a_pat_insurance_companies_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_insurance_companies', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_insurance_companies', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_pat_insurance_companies_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_insurance_companies', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_insurance_companies', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_pat_insurance_companies_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_insurance_companies', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_pat_insurance_companies', {});
                    this.dispatch('a_notify', {
                        message: 'Položka byla smazána.',
                    }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', {
                        message: 'Položka je již použita a nemůže být smazána',
                    }, { root: true });
                });
        },


        a_op_cis_res_kompl({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_op_cis_res_kompl', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_op_cis_res_kompl', response.data["l_op_cis_res_kompl"]);
                    commit('m_op_komplikace', response.data["op_komplikace"]);

                }, error => {
                    console.log(error);
                });
        },


        a_op_cis_res_kompl_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_op_cis_res_kompl', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_op_cis_res_kompl', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_op_cis_res_kompl_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_op_cis_res_kompl', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_op_cis_res_kompl', {});
                    this.dispatch('a_notify', {
                        message: 'Položka byla smazána.',
                    }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', {
                        message: 'Položka je již použita a nemůže být smazána',
                    }, { root: true });
                });
        },


        a_med_cis_bio_ter_lek({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_med_cis_bio_ter_lek', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_med_cis_bio_ter_lek', response.data["l_med_cis_bio_ter_lek"]);
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_bio_ter_lek_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_med_cis_bio_ter_lek', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_bio_ter_lek', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_bio_ter_lek_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_med_cis_bio_ter_lek', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_bio_ter_lek', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_bio_ter_lek_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_med_cis_bio_ter_lek', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_bio_ter_lek', {});
                    this.dispatch('a_notify', { message: 'Položka byla smazána.', }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', { message: 'Položka je již použita a nemůže být smazána', }, { root: true });
                });
        },


        a_med_cis_protokol({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_med_cis_protokol', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_med_cis_protokol', response.data["l_med_cis_protokol"]);

                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_protokol_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_med_cis_protokol', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_protokol', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_protokol_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_med_cis_protokol', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_protokol', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_protokol_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_med_cis_protokol', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_protokol', {});
                    this.dispatch('a_notify', { message: 'Položka byla smazána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_chem_int_inthe_inver_cyt({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_med_cis_chem_int_inthe_inver_cyt', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_med_cis_chem_int_inthe_inver_cyt', response.data["l_med_cis_chem_int_inthe_inver_cyt"]);

                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_chem_int_inthe_inver_cyt_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_med_cis_chem_int_inthe_inver_cyt', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_chem_int_inthe_inver_cyt', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_chem_int_inthe_inver_cyt_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_med_cis_chem_int_inthe_inver_cyt', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_chem_int_inthe_inver_cyt', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_chem_int_inthe_inver_cyt_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_med_cis_chem_int_inthe_inver_cyt', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_chem_int_inthe_inver_cyt', {});
                    this.dispatch('a_notify', {
                        message: 'Položka byla smazána.',
                    }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_chem_int_cyt({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_med_cis_chem_int_cyt', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_med_cis_chem_int_cyt', response.data["l_med_cis_chem_int_cyt"]);

                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_chem_int_cyt_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_med_cis_chem_int_cyt', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_chem_int_cyt', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_chem_int_cyt_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_med_cis_chem_int_cyt', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_chem_int_cyt', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_chem_int_cyt_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_med_cis_chem_int_cyt', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_chem_int_cyt', {});
                    this.dispatch('a_notify', { message: 'Položka byla smazána.', }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', { message: 'Položka je již použita a nemůže být smazána', }, { root: true });
                });
        },


        a_med_cis_udr_chem_inthe_inver_cyt({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_med_cis_udr_chem_inthe_inver_cyt', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_med_cis_udr_chem_inthe_inver_cyt', response.data["l_med_cis_udr_chem_inthe_inver_cyt"]);

                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_udr_chem_inthe_inver_cyt_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_med_cis_udr_chem_inthe_inver_cyt', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_udr_chem_inthe_inver_cyt', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_udr_chem_inthe_inver_cyt_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_med_cis_udr_chem_inthe_inver_cyt', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_udr_chem_inthe_inver_cyt', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_udr_chem_inthe_inver_cyt_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_med_cis_udr_chem_inthe_inver_cyt', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_udr_chem_inthe_inver_cyt', {});
                    this.dispatch('a_notify', { message: 'Položka byla smazána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_kompl_dr({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_med_cis_kompl_dr', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_med_cis_kompl_dr', response.data["l_med_cis_kompl_dr"]);
                    commit('m_med_komplikace', response.data["med_komplikace"]);

                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_kompl_dr_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_med_cis_kompl_dr', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_kompl_dr', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_med_cis_kompl_dr_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_med_cis_kompl_dr', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_med_cis_kompl_dr', {});
                    this.dispatch('a_notify', { message: 'Položka byla smazána.', }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', { message: 'Položka je již použita a nemůže být smazána', }, { root: true });
                });
        },


        a_exam_cis_diag_group_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/cis_diag_groups', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_exam_cis_diag_groups_get', {});
                    this.dispatch('a_notify', {message: 'Skupina byla přidána.',}, { root: true });

                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_diag_group_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/cis_diag_groups', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_exam_cis_diag_groups_get', {});
                    this.dispatch('a_exam_cis_diags_get', {});
                    this.dispatch('a_notify', {message: 'Skupina byla změněna.',}, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_diag_group_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/cis_diag_groups', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_exam_cis_diag_groups_get', {});
                    this.dispatch('a_exam_cis_diags_get', {});
                    this.dispatch('a_notify', { message: 'Skupina byla smazána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_diag_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/cis_diags', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_exam_cis_diags_get', {});
                    this.dispatch('a_notify', {message: 'Položka byla přidána.',}, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_diag_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/cis_diags', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_exam_cis_diags_get', {});
                    this.dispatch('a_notify', {message: 'Položka byla změněna.',}, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_diag_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/cis_diags', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_exam_cis_diags_get', {});
                    this.dispatch('a_notify', {message: 'Položka byla smazána.',}, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_diag_groups_get({ state, commit }, payload ) {
            axios.get(process.env.VUE_APP_BE + '/cis_diag_groups', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_l_diag_groups', response.data["l_diag_groups"]);
                    commit('m_d_diag_groups', response.data["d_diag_groups"]);
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_diags_get({ state, commit }, payload ) {
            axios.get(process.env.VUE_APP_BE + '/cis_diags', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_l_cis_diags', response.data["l_cis_diags"]);
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_sk_nadoru_get({ state, commit }, payload ) {
            axios.get(process.env.VUE_APP_BE + '/exam_cis_sk_nadoru', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_l_exam_cis_sk_nadoru', response.data["l_exam_cis_sk_nadoru"]);
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_pn_lok_topo_prim({ state, commit }, ) {
            let payload = {...state.sorting_lok_topo_prims};
            axios.get(process.env.VUE_APP_BE + '/l_exam_cis_pn_lok_topo_prim', { params: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_exam_cis_pn_lok_topo_prim', response.data["l_exam_cis_pn_lok_topo_prim"]);

                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_pn_lok_topo_prim_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_exam_cis_pn_lok_topo_prim', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_exam_cis_pn_lok_topo_prim', {});
                    this.dispatch('a_notify', {message: 'Název byl přidán.',}, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_pn_lok_topo_prim_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_exam_cis_pn_lok_topo_prim', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_exam_cis_pn_lok_topo_prim', {});
                    this.dispatch('a_notify', {message: 'Název byl změněn.',}, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_exam_cis_pn_lok_topo_prim_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_exam_cis_pn_lok_topo_prim', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_exam_cis_pn_lok_topo_prim', {});
                    this.dispatch('a_notify', { message: 'Název byl smazán.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_check_cis_dept({ state, commit }, ) {
            axios.get(process.env.VUE_APP_BE + '/l_check_cis_dept', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_check_cis_dept', response.data["l_check_cis_dept"]);

                }, error => {
                    console.log(error);
                });
        },


        a_check_cis_dept_add({ state, commit, dispatch }, payload) {
            axios.post(process.env.VUE_APP_BE + '/l_check_cis_dept', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_check_cis_dept', {});
                    this.dispatch('a_notify', { message: 'Položka byla přidána.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_check_cis_dept_update({ state, commit, dispatch }, payload) {
            axios.put(process.env.VUE_APP_BE + '/l_check_cis_dept', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_check_cis_dept', {});
                    this.dispatch('a_notify', { message: 'Položka byla změněna.', }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_check_cis_dept_delete({ state, commit }, payload) {
            axios.delete(process.env.VUE_APP_BE + '/l_check_cis_dept', { data: payload, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_check_cis_dept', {});
                    this.dispatch('a_notify', { message: 'Položka byla smazána.', }, { root: true });
                }, error => {
                    console.log(error);
                    this.dispatch('a_notify', { message: 'Položka je již použita a nemůže být smazána', }, { root: true });
                });
        },


        a_reviews({ state, commit } ) {
            state.loading_reviews = true;
            let payload = {...state.sorting_reviews};
            payload["id_patient"] = state.patient.id_patient;

            axios.get(process.env.VUE_APP_BE + '/reviews', { withCredentials: true, params: payload, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_reviews', response.data["reviews"]);
                    state.loading_reviews = false;
                }, error => {
                    console.log(error);
                    state.loading_reviews = false;
                });
        },


        a_ad_settings({ state, commit } ) {
            state.loading_ad_settings = true;

            this.dispatch('a_pat_cis_syn_pre_var', {});
            this.dispatch('a_pat_cis_syn_pre_gen', {});
            this.dispatch('a_pat_cis_prv_priz_fok_def', {});
            this.dispatch('a_pat_skola', {});
            this.dispatch('a_pat_insurance_companies', {});
            this.dispatch('a_exam_cis_pn_lok_topo_prim', {});
            this.dispatch('a_exam_cis_diag_groups_get', {});
            this.dispatch('a_exam_cis_diags_get', {});
            this.dispatch('a_op_cis_res_kompl', {});
            this.dispatch('a_med_cis_protokol', {});
            this.dispatch('a_med_cis_chem_int_inthe_inver_cyt', {});
            this.dispatch('a_med_cis_udr_chem_inthe_inver_cyt', {});
            this.dispatch('a_med_cis_chem_int_cyt', {});
            this.dispatch('a_med_cis_kompl_dr', {});
            this.dispatch('a_med_cis_bio_ter_lek', {});
            this.dispatch('a_check_cis_dept', {});

            setTimeout(() => {
                state.loading_ad_settings = false;
            }, 2000);

        },


    },


});

export default store;
